module.exports = __webpack_public_path__ + "static/media/mp-roundup.568e94e8.png";